import * as React from "react";
import { ensureLinesExist } from "../api/lineExistence";

export function useLineExistence(ids: string[]) {
  const [existing, setExisting] = React.useState<Set<string>>(new Set());
  const [loading, setLoading] = React.useState(false);

  const key = React.useMemo(() => ids.slice().sort().join(","), [ids]);

  React.useEffect(() => {
    if (!ids.length) {
      setExisting(new Set());
      return;
    }
    const ctrl = new AbortController();
    let mounted = true;

    (async () => {
      setLoading(true);
      try {
        const res = await ensureLinesExist(ids, {
          concurrency: 4,
          signal: ctrl.signal,
        });
        if (!mounted) return;
        const okSet = new Set<string>();
        for (const id of ids) if (res[String(id)]) okSet.add(String(id));
        setExisting(okSet);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
      ctrl.abort();
    };
  }, [key]);

  return { existing, loading };
}
